import React from 'react';

import { DetailsModalHeader } from './details-modal-header';
import { FreeDropRules } from './free-drop-rules';
import { LevelsTable } from './levels-table';

interface FreeDropsDetailsModalProps {
  minGoal: number;
  nextDropDate: Date | null;
}

export const FreeDropsDetailsModal: React.FC<FreeDropsDetailsModalProps> = ({
  minGoal,
  nextDropDate
}) => {

  return (
    <div className="free-drop-popup-wrapper">
      <div className="free-drop-popup-holder">

        <DetailsModalHeader nextDropDate={nextDropDate} />

        <div className="free-drop-popup-content">

          <LevelsTable />

          <FreeDropRules minGoal={minGoal} />

        </div>

      </div>
    </div>
  );
};
